module.exports = __webpack_public_path__ + "media/clerk.e5d00457.mp4";